<template>
  <div class="banner-contato">
    <h3>Contatos da Unidade de Movimentação de Servidores</h3>
    <div class="contatos">
      <div class="contato-item">
        <a href="https://api.whatsapp.com/send?phone=556232015854" target="_blank">
          <img src="/icons/whatsapp.png" alt="Ícone Telefone" class="icon">
          <strong>Telefone / WhatsApp:</strong>
          <span>(62) 3201-5854</span>
        </a>
      </div>
      <div class="contato-item">
        <img src="/icons/email.png" alt="Ícone Email" class="icon">
        <strong>Email:</strong>
        <span>umov.casacivil@goias.gov.br</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerContato",
};
</script>

<style scoped lang="scss">
.banner-contato {
  width: 100%;
  height: auto;
  margin: 0;
  padding: 2rem;
  background-color: #f0f7f0;
  border-left: 5px solid #005516;
  border-right: 5px solid #005516;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  font-family: "Montserrat-Medium", sans-serif;
  text-align: center;
}

.banner-contato h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #005516;
  font-size: 1.3rem;
  text-align: center;
}

.contatos {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
}

.contato-item {
  display: flex;
  align-items: center;
}

.contato-item strong {
  margin-right: 0.5rem;
  font-size: 0.96rem;
}

.contato-item span {
  font-size: 0.96rem;
}

.contato-item a {
  color: #212529;
  text-decoration: none;
}

.contato-item a:hover {
  text-decoration: underline;
}

.icon {
  margin-right: 8px;
  width: 19px;
  height: 19px;
}
</style>